module.exports = "<input v-model=fragment placeholder={placeholder}>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ValueString.vue
 ** module id = 149
 ** module chunks = 0
 **/